import { useState, type FormEvent } from "react";
import Modal from "./Modal";
import "./WaitlistModal.css";

interface WaitlistModalProps {
    open: boolean;
    onClose: () => void;
    /** Wire this up to your actual API call. */
    onSubmit?: (data: { email: string; message: string }) => void;
}

export default function WaitlistModal({ open, onClose, onSubmit }: WaitlistModalProps) {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        onSubmit?.({ email, message });
        setSubmitted(true);
    };

    const handleClose = () => {
        onClose();
        setTimeout(() => {
            setEmail("");
            setMessage("");
            setSubmitted(false);
        }, 200);
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            title={submitted ? "You're on the list" : "Join the waitlist"}
        >
            {submitted ? (
                <p className="waitlist-modal__success">
                    Thanks — we'll email <strong>{email || "you"}</strong> as soon as a spot opens up.
                </p>
            ) : (
                <form className="waitlist-form" onSubmit={handleSubmit}>
                    <p className="waitlist-form__intro">
                        Leave your email and tell us what you're hoping to see in Eolass for schools. We'll reach out as soon as the product is ready.
                    </p>

                    <label className="waitlist-form__field">
                        <span>Email</span>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@example.com"
                        />
                    </label>

                    <label className="waitlist-form__field">
                        <span>Anything specific you're looking for?</span>
                        <textarea
                            required
                            rows={3}
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            placeholder="e.g. easy editing tools, generation customization..."
                        />
                    </label>

                    <button type="submit" className="waitlist-form__submit">
                        Join the waitlist
                    </button>
                </form>
            )}
        </Modal>
    );
}